import { Link, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import { useAuth } from "../../context/AuthContext";

export default function Dashboard() {
  const { hasPermission, user, logout } = useAuth();
  const navigate = useNavigate();
  const [isRedirecting, setIsRedirecting] = useState(false);

  useEffect(() => {
    // Debug log to check user data

    
    // Check if user exists and has USER role
    if (user && user.role && user.role.toLowerCase() === 'user') {

      setIsRedirecting(true);
      navigate(`/users/${user.id}`);
    }
  }, [user, navigate]);

  // If redirecting, show loading state
  if (isRedirecting) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Omdirigerer til din profil...</p>
      </div>
    );
  }

  // If user is not loaded yet, show loading state
  if (!user) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Laster...</p>
      </div>
    );
  }

  return (
    <div className="dashboard-layout">
      <nav className="sidebar">
        <div className="sidebar-header">
          <h2>Hurtiglenker</h2>
        </div>
        <ul className="sidebar-nav">
          <li>
            <Link to="/dashboard">
              <i className="fas fa-home"></i> Dashboard
            </Link>
          </li>
          {(hasPermission("canViewPrograms") || hasPermission("canCreatePrograms")) && (
            <li>
              <Link to="/programs">
                <i className="fas fa-list"></i> Programmer
              </Link>
            </li>
          )}
          {hasPermission("canManageAllBusinesses") && (
            <li>
              <Link to="/lopsteknikk-users">
                <i className="fas fa-running"></i> Løpsteknikk
              </Link>
            </li>
          )}
          {(hasPermission("canManageActivities") || hasPermission("canViewActivities")) && (
            <li>
              <Link to="/activities">
                <i className="fas fa-tasks"></i> Aktiviteter
              </Link>
            </li>
          )}
          {hasPermission("canManagePlaylists") && (
            <li>
              <Link to="/playlists">
                <i className="fas fa-list"></i> Spillelister
              </Link>
            </li>
          )}
          {hasPermission("canManageAllBusinesses") && (
            <>
              {/* <li>
                <Link to="/levels/new">
                  <i className="fas fa-layer-group"></i> Levels
                </Link>
              </li> */}
          {(hasPermission("canManageAllBusinesses") || hasPermission("canManageOwnBusiness")) && (
            <li>
              <Link to="/albums">
                <i className="fas fa-images"></i> Album
              </Link>
            </li>
          )}
              {user?.businessAdminFor ? (
                <li>
                  <Link to="/businesses/current">
                    <i className="fas fa-building"></i> Min bedrift
                  </Link>
                </li>
              ) : (
                <li>
                  <Link to="/businesses">
                    <i className="fas fa-building"></i> Bedrifter
                  </Link>
                </li>
              )}
              <li>
                <Link to="/users/">
                  <i className="fas fa-user-plus"></i> Brukere
                </Link>
              </li>
            </>
          )}
          {hasPermission("canManageOwnBusiness") && (
            <li>
              <Link to="/business">
                <i className="fas fa-building"></i> Bedriftsinformasjon
              </Link>
            </li>
          )}
          {hasPermission("canViewOwnProfile") && (
            <li>
              <Link to={`/users/${user?.id}`}>
                <i className="fas fa-user"></i> Min profil
              </Link>
            </li>
          )}
          {hasPermission("canManageAllBusinesses") ? (
            <li>
              <Link to="/subscriptions">
                <i className="fas fa-credit-card"></i> Administrer abonnementer
              </Link>
            </li>
          ) : hasPermission("canManageOwnSubscription") && (
            <li>
              <Link to="/subscriptions/plans">
                <i className="fas fa-tag"></i> Abonnementsplaner
              </Link>
            </li>
          )}
          <li>
            <Link to="/mailerlite">
              <i className="fas fa-envelope"></i> Nyhetsbrev
            </Link>
          </li>
          {hasPermission("canManageAllBusinesses") && (
            <li>
              <Link to="/translations">
                <i className="fas fa-book"></i> Oversettelser
              </Link>
            </li>
          )}
          {user?.role === 'superadmin' && (
            <li>
              <Link to="/analytics">
                <i className="fas fa-chart-bar"></i> Analytics
              </Link>
            </li>
          )}
          {hasPermission("canManageAllBusinesses") && (
            <li>
              <Link to="/cache-management">
                <i className="fas fa-database"></i> Cache Management
              </Link>
            </li>
          )}

        </ul>
      </nav>

      <div className="dashboard-container">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
          }}
        >
          <h1>Dashboard</h1>
          <button
            onClick={logout}
            style={{
              padding: "8px 16px",
              backgroundColor: "#dc3545",
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              maxWidth: "100px",
            }}
          >
            <i className="fas fa-sign-out-alt"></i> Logg ut
          </button>
        </div>

        {user?.businessAdminFor && (
          <div className="dashboard-section">
            <div className="dashboard-grid">
              <Link to="/businesses/current" className="dashboard-item">
                <div className="dashboard-box" style={{ borderColor: "var(--primary-color)", background: "var(--primary-light)" }}>
                  <i className="fas fa-building" style={{ color: "var(--primary-dark)" }}></i>
                  <h2>Gå til min bedrift</h2>
                  <p>Administrer {user.businessAdminFor.name} – brukere og abonnement</p>
                </div>
              </Link>
            </div>
          </div>
        )}

        <div className="dashboard-section">
          <h2 className="section-title">Første oppsett</h2>
          <div className="dashboard-grid">
            {hasPermission("canManageAllBusinesses") && (
              <>
   


                <Link to="/levels/new" className="dashboard-item">
                  <div className="dashboard-box">
                    <i className="fas fa-layer-group"></i>
                    <h2>Ny nivå</h2>
                    <p>Opprett og administrer intensitetsnivåer</p>
                  </div>
                </Link>

                <Link to="/steps" className="dashboard-item">
                  <div className="dashboard-box">
                    <i className="fas fa-shoe-prints"></i>
                    <h2>Nytt steg</h2>
                    <p>Opprett og administrer steg</p>
                  </div>
                </Link>

                <Link to="/environment" className="dashboard-item">
                  <div className="dashboard-box">
                    <i className="fas fa-tree"></i>
                    <h2>Nytt miljø</h2>
                    <p>Opprett treningsmiljøer</p>
                  </div>
                </Link>
              </>
            )}

            {hasPermission("canViewOwnProfile") && !hasPermission("canManageAllBusinesses") && (
              <>
                <Link to={`/users/${user?.id}`} className="dashboard-item">
                  <div className="dashboard-box">
                    <i className="fas fa-user"></i>
                    <h2>Min profil</h2>
                    <p>Se og rediger din profilinformasjon</p>
                  </div>
                </Link>

                <Link to="/subscriptions" className="dashboard-item">
                  <div className="dashboard-box">
                    <i className="fas fa-credit-card"></i>
                    <h2>Mitt abonnement</h2>
                    <p>Administrer dine abonnementsdetaljer</p>
                  </div>
                </Link>
              </>
            )}
          </div>
        </div>


        {hasPermission("canManageAllBusinesses") && (
              <>
        <div className="dashboard-section">
          <h2 className="section-title">Innholdsadministrasjon</h2>
          <div className="dashboard-grid">
            {hasPermission("canManageAllBusinesses") && (
              <>
                <Link to="/activities/new" className="dashboard-item">
                  <div className="dashboard-box">
                    <i className="fas fa-plus-circle"></i>
                    <h2>Ny aktivitet</h2>
                    <p>Legg til en ny aktivitet</p>
                  </div>
                </Link>
                <Link to="/programs/new" className="dashboard-item">
                  <div className="dashboard-box">
                    <i className="fas fa-plus-circle"></i>
                    <h2>Nytt program</h2>
                    <p>Opprett og konfigurer et nytt program</p>
                  </div>
                </Link>

              

                <Link to="/media/upload" className="dashboard-item">
                  <div className="dashboard-box">
                    <i className="fas fa-cloud-upload-alt"></i>
                    <h2>Last opp media</h2>
                    <p>Last opp og administrer mediefiler</p>
                  </div>
                </Link>

       
              </>
            )}

            {hasPermission("canManagePlaylists") && (
              <>
                <Link to="/playlists/new" className="dashboard-item">
                  <div className="dashboard-box">
                    <i className="fas fa-plus-circle"></i>
                    <h2>Ny spilleliste</h2>
                    <p>Opprett og administrer spillelister</p>
                  </div>
                </Link>
              </>
            )}
            {hasPermission("canManageAllBusinesses") && (
  <>

    <Link to="/albums/new" className="dashboard-item">
      <div className="dashboard-box">
        <i className="fas fa-images"></i>
        <h2>Nytt album</h2>
        <p>Opprett og administrer fotoalbum</p>
      </div>
    </Link>
  </>
)}
            {hasPermission("canViewActivities") && <>
                <Link to="/activities" className="dashboard-item">
                                    <div className="dashboard-box">
                                        <i className="fas fa-plus-circle"></i>
                                        <h2>Aktiviteter</h2>
                                        {/* <p>Add a new activity</p> */}
                                    </div>
                                </Link>
            </>}
            {hasPermission("canViewPrograms") && <>
                <Link to="/programs" className="dashboard-item">
                                    <div className="dashboard-box">
                                        <i className="fas fa-plus-circle"></i>
                                        <h2>Programmer</h2>
                                        {/* <p>Create and configure a new program</p> */}
                                    </div>
                                </Link>
            </>}
            {hasPermission("canManageAllBusinesses") && <>
            <Link to="/exercise-of-week" className="dashboard-item">
                    <div className="dashboard-box">
                        <i className="fas fa-dumbbell"></i>
                        <h2>Ukens øvelse</h2>
                        <p>Administrer ukentlig utvalgt innhold</p>
                    </div>
                </Link>
                </>}
          </div>
        </div>
        </>
        )}

{hasPermission("canManageAllBusinesses") && (
<>
        <div className="dashboard-section">
          <h2 className="section-title">
            {hasPermission("canManageAllBusinesses")
              ? "Bedriftsadministrasjon"
              : hasPermission("canManageOwnBusiness") 
                ? "Bedriftsinformasjon" 
                : "Kontoadministrasjon"}
          </h2>
          <div className="dashboard-grid">
            {hasPermission("canManageAllBusinesses") ? (
              <>
                <Link to="/users/new" className="dashboard-item">
                  <div className="dashboard-box">
                    <i className="fas fa-user-plus"></i>
                    <h2>Ny bruker</h2>
                    <p>Legg til og administrer systembrukere</p>
                  </div>
                </Link>

                <Link to="/mailerlite" className="dashboard-item">
                  <div className="dashboard-box">
                    <i className="fas fa-envelope"></i>
                    <h2>Nyhetsbrev</h2>
                    <p>Administrer nyhetsbrev-grupper og abonnenter</p>
                  </div>
                </Link>

                <Link to="/email-management" className="dashboard-item">
                  <div className="dashboard-box">
                    <i className="fas fa-paper-plane"></i>
                    <h2>E-post administrasjon</h2>
                    <p>Send e-post til brukere med BCC</p>
                  </div>
                </Link>

              </>
            ) : hasPermission("canManageOwnBusiness") ? (
              <Link to="/business" className="dashboard-item">
                <div className="dashboard-box">
                  <i className="fas fa-building"></i>
                  <h2>Bedriftsdetaljer</h2>
                  <p>Se bedriftsinformasjon</p>
                </div>
              </Link>
            ) : hasPermission("canManageOwnSubscription") && (
              <Link to="/subscriptions/plans" className="dashboard-item">
                <div className="dashboard-box">
                  <i className="fas fa-credit-card"></i>
                  <h2>Abonnementsplaner</h2>
                  <p>Se og kjøp abonnementsplaner</p>
                </div>
              </Link>
            )}

            <Link to="/subscriptions" className="dashboard-item" 
                  style={{ display: hasPermission("canManageAllBusinesses") ? 'block' : 'none' }}>
              <div className="dashboard-box">
                <i className="fas fa-credit-card"></i>
                <h2>Abonnementer</h2>
                <p>
                  {hasPermission("canManageAllBusinesses")
                    ? "Administrer abonnementsplaner"
                    : hasPermission("canManageOwnSubscription")
                    ? "Se abonnementsdetaljer"
                    : "Ingen tilgang til abonnementsdetaljer"}
                </p>
              </div>
            </Link>
          </div>
        </div>
        </>
        )}
      </div>
    </div>
  );
}
